import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';

import Button from 'Mui/Button';
import Typography from '@material-ui/core/Typography';

import { system900 } from 'Mui/styles/color';
import { below } from 'utils/breakpoint';

function PaySuccess({ onConfirm = () => {}, needPoints }) {
    return (
        <>
            <div css={contentStyle}>
                <Typography variant="h6">{i18n.t('label.join_success')}</Typography>
                <Typography variant="h6">
                    {i18n.t('label.already_decrease_point', { count: needPoints })}
                </Typography>
            </div>
            <div css={btnContainerStyle}>
                <Button variant="contained" onClick={onConfirm} css={successBtnStyle}>
                    {i18n.t('btn.continue')}
                </Button>
            </div>
        </>
    );
}

export default PaySuccess;

const contentStyle = css`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const btnContainerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
`;

const successBtnStyle = css`
    background: ${system900.color};
    color: #fff;
    &:hover {
        background: rgba(85, 85, 85, 0.8);
    }
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;
